import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "compare",
  label: "Product Comparison",
  description: "Up to 4 pieces side by side: room photo, name, category and brand, price with the saving and lowest price, EMI per month, W × D × H drawn to one scale, wood, finish, warranty and every other attribute, with a show-differences-only switch, add to cart and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table",
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
